import { configureStore } from '@reduxjs/toolkit';
import { waitlistApi } from './services/waitlist/waitlistApi';
import authReducer from './services/auth/authSlice';
import maintenanceReducer from './slices/maintenanceSlice';
import rateLimitReducer from './slices/rateLimitSlice';
import activityReducer from './slices/activitySlice';
import messageReducer from './slices/messageSlice';
import pointsReducer from './slices/pointsSlice';
import importReducer from './slices/importSlice';
import { setupListeners } from '@reduxjs/toolkit/query';
import { authApi } from './services/auth/authApi';
import { cardsSearchApi } from './services/cards/search/cardsSearchApi';
import { meApi } from './services/user/meApi';
import { haveListApi } from './services/collectionList/haveList/haveListApi';
import { wantListApi } from './services/collectionList/wantList/wantListApi';
import { publicCollectionApi } from './services/collection/publicCollectionApi';
import { adminApi } from './services/admin/adminApi';
import { tradeApi } from './services/trade/tradeApi';
import { tradePriceApi } from './services/trade/tradePriceApi';
import { feedbackApi } from './services/feedback/feedbackApi';
import { messageApi } from './services/message/messageApi';
import { caseApi } from './services/case/caseApi';
import { transactionApi } from './services/transaction/transactionApi';
import { economicApi } from './services/economic/economicApi';
import { blogApi } from './services/blog/blogApi';
import { dripCampaignApi } from './services/dripCampaign/dripCampaignApi';
import { settingsApi } from './services/settings/settingsApi';
import { uiPreferencesApi } from './services/settings/uiPreferencesApi';
import { adminCardPricingApi } from './services/admin/adminCardPricingApi';
import { setsApi } from './services/sets/setsApi';
import { publicSetsApi } from './services/sets/publicSetsApi';
import { decklistApi } from './services/cards/decklistApi';
import { onboardingApi } from './services/onboarding/onboardingApi';
import { activityApi } from './services/activity/activityApi';
import { importApi } from './services/import/importApi';
import { tradeRatingApi } from './services/trade/tradeRatingApi';
import { profileApi } from './services/profile/profileApi';
import { analyticsApi } from './services/admin/analyticsApi';
import { leaderboardApi } from './services/leaderboard/leaderboardApi';
import { pointsApi } from './services/points/pointsApi';
import { subscriptionApi } from './services/subscription/subscriptionApi';
import { badgeApi } from './services/badge/badgeApi';
import { emojiApi } from './services/emoji/emojiApi';
import { broadcastApi } from './services/broadcast/broadcastApi';
import { adminSeoApi } from './services/admin/adminSeoApi';
import { feedApi } from './services/feed/feedApi';
import { followingFeedApi } from './services/feed/followingFeedApi';
import { followApi } from './services/social/followApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    maintenance: maintenanceReducer,
    rateLimit: rateLimitReducer,
    activity: activityReducer,
    message: messageReducer,
    points: pointsReducer,
    import: importReducer,
    [authApi.reducerPath]: authApi.reducer,
    [waitlistApi.reducerPath]: waitlistApi.reducer,
    [cardsSearchApi.reducerPath]: cardsSearchApi.reducer,
    [meApi.reducerPath]: meApi.reducer,
    [haveListApi.reducerPath]: haveListApi.reducer,
    [wantListApi.reducerPath]: wantListApi.reducer,
    [publicCollectionApi.reducerPath]: publicCollectionApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
    [tradeApi.reducerPath]: tradeApi.reducer,
    [tradePriceApi.reducerPath]: tradePriceApi.reducer,
    [feedbackApi.reducerPath]: feedbackApi.reducer,
    [messageApi.reducerPath]: messageApi.reducer,
    [caseApi.reducerPath]: caseApi.reducer,
    [transactionApi.reducerPath]: transactionApi.reducer,
    [economicApi.reducerPath]: economicApi.reducer,
    [blogApi.reducerPath]: blogApi.reducer,
    [dripCampaignApi.reducerPath]: dripCampaignApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    [uiPreferencesApi.reducerPath]: uiPreferencesApi.reducer,
    [adminCardPricingApi.reducerPath]: adminCardPricingApi.reducer,
    [setsApi.reducerPath]: setsApi.reducer,
    [publicSetsApi.reducerPath]: publicSetsApi.reducer,
    [decklistApi.reducerPath]: decklistApi.reducer,
    [onboardingApi.reducerPath]: onboardingApi.reducer,
    [activityApi.reducerPath]: activityApi.reducer,
    [importApi.reducerPath]: importApi.reducer,
    [tradeRatingApi.reducerPath]: tradeRatingApi.reducer,
    [profileApi.reducerPath]: profileApi.reducer,
    [analyticsApi.reducerPath]: analyticsApi.reducer,
    [leaderboardApi.reducerPath]: leaderboardApi.reducer,
    [pointsApi.reducerPath]: pointsApi.reducer,
    [subscriptionApi.reducerPath]: subscriptionApi.reducer,
    [badgeApi.reducerPath]: badgeApi.reducer,
    [emojiApi.reducerPath]: emojiApi.reducer,
    [broadcastApi.reducerPath]: broadcastApi.reducer,
    [adminSeoApi.reducerPath]: adminSeoApi.reducer,
    [feedApi.reducerPath]: feedApi.reducer,
    [followingFeedApi.reducerPath]: followingFeedApi.reducer,
    [followApi.reducerPath]: followApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(waitlistApi.middleware)
      .concat(authApi.middleware)
      .concat(cardsSearchApi.middleware)
      .concat(meApi.middleware)
      .concat(haveListApi.middleware)
      .concat(wantListApi.middleware)
      .concat(publicCollectionApi.middleware)
      .concat(adminApi.middleware)
      .concat(tradeApi.middleware)
      .concat(tradePriceApi.middleware)
      .concat(feedbackApi.middleware)
      .concat(messageApi.middleware)
      .concat(caseApi.middleware)
      .concat(transactionApi.middleware)
      .concat(economicApi.middleware)
      .concat(blogApi.middleware)
      .concat(dripCampaignApi.middleware)
      .concat(settingsApi.middleware)
      .concat(uiPreferencesApi.middleware)
      .concat(adminCardPricingApi.middleware)
      .concat(setsApi.middleware)
      .concat(publicSetsApi.middleware)
      .concat(decklistApi.middleware)
      .concat(onboardingApi.middleware)
      .concat(activityApi.middleware)
      .concat(importApi.middleware)
      .concat(tradeRatingApi.middleware)
      .concat(profileApi.middleware)
      .concat(analyticsApi.middleware)
      .concat(leaderboardApi.middleware)
      .concat(pointsApi.middleware)
      .concat(subscriptionApi.middleware)
      .concat(badgeApi.middleware)
      .concat(emojiApi.middleware)
      .concat(broadcastApi.middleware)
      .concat(adminSeoApi.middleware)
      .concat(feedApi.middleware)
      .concat(followingFeedApi.middleware)
      .concat(followApi.middleware),
});

// Optional: Infer types for RootState and AppDispatch
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

setupListeners(store.dispatch);
